import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "subtituloHEXAText" }
const _hoisted_2 = { class: "tituloHEXAText" }

import { computed } from 'vue';

interface Props {
    title: string
    subtitle: string,
    color: string
    icon: string
    sizeHexa?: number
    sizeTitle?: number
    sizeSubTi?: number
    colorText?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HexagonRAOS',
  props: {
    title: {},
    subtitle: {},
    color: {},
    icon: {},
    sizeHexa: { default: 110 },
    sizeTitle: { default: 45 },
    sizeSubTi: { default: 20 },
    colorText: { default: 'white' }
  },
  setup(__props: any) {

const props = __props

const sizeHexa      = computed(() => props.sizeHexa);
const sizeTitle     = computed(() => props.sizeTitle);
const sizeSubTi     = computed(() => props.sizeSubTi);
const colorHexagon  = computed(() => props.color);
const finalColorT   = computed(() => props.colorText)


const styles = computed(() =>  ({
    '--varColor' : colorHexagon.value,
    '--varSizeHexa': `${sizeHexa.value}px`,
    '--varSizeTitle': `${sizeTitle.value}px`,
    '--varSizeSubTi': `${sizeSubTi.value}px`,
    '--varColorText' : finalColorT.value
}))


return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(styles.value),
    class: "contenedorHEXA"
  }, [
    _createVNode(_component_v_sheet, { class: "hexagon" }),
    _createVNode(_component_v_sheet, {
      class: "iconHEXACard text-center",
      width: sizeHexa.value-5,
      color: "transparent"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, { color: __props.colorText }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.icon), 1)
          ]),
          _: 1
        }, 8, ["color"])
      ]),
      _: 1
    }, 8, ["width"]),
    _createVNode(_component_v_sheet, {
      class: "subtituloHEXACard text-center",
      width: sizeHexa.value-5,
      color: "transparent"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(__props.subtitle), 1)
      ]),
      _: 1
    }, 8, ["width"]),
    _createVNode(_component_v_sheet, {
      class: "tituloHEXACard text-center",
      width: sizeHexa.value-5,
      color: "transparent"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(__props.title), 1)
      ]),
      _: 1
    }, 8, ["width"])
  ], 4))
}
}

})